import yup from '../../../config/yup';

export const sftpWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('sftpWriter'),
  delayedRead: yup.boolean(),
  format: yup.string(),
  properties: yup.object().shape({
    debug: yup.boolean(),
    credentialType: yup.string(),
    host: yup.string(),
    user: yup.string(),
    password: yup.string(),
    privateKey: yup.string(),
    passphrase: yup.string(),
    port: yup.number().positive('Port must be a positive number'),
    path: yup.string().required('Path is required'),
    writeLevel: yup.string(),
    fileName: yup.string(),
  }),
});
